// @ts-nocheck


import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import notification from 'antd/lib/notification';

import moment from 'moment';
import React, { useState } from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../../components/ant/DatePicker';

import { Form, Selects } from './../../../components';

import { Section, SectionTitle } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';
import { maintenanceApi, maintenanceMatrixApi } from './../../../lib/api';
import {
  maintenanceMatrixValidActionEnum,
  orderContractorTypeEnum,
  ownerTypes,
  repairPlanEnum,
  serviceTypeEnum } from
'./../../../lib/enum';



const {
  VehicleSelect,
  RepairePlanSelect,
  OrderContractorTypeSelect,
  MaintenanceWorkTypeSelect,
  ContractorSelect
} = Selects;
const TextArea = Input.TextArea;

const Content = styled.div.withConfig({ displayName: "InnerForm__Content", componentId: "sc-1cplgnu-0" })(["padding:16px;"]);


const Footer = styled(Section).withConfig({ displayName: "InnerForm__Footer", componentId: "sc-1cplgnu-1" })(["padding:16px;display:flex;justify-content:space-between;align-items:center;"]);

















export default ({ onSubmit, initialValue }) => {
  const [maintenanceMatrix, setMaintenanceMatrix] = useState(null);
  // отображать или нет подрядчика
  const showContractor = (maintenance) => {
    return (
      maintenance.orderContractorType === orderContractorTypeEnum.contractor);

  };
  // выводим предупреждение если нет направления расхода
  const checkExpenseDirection = async (params) => {
    if (
    !!params.maintenanceWorkTypeId &&
    params.orderContractorType &&
    params.repairPlan)
    {
      try {
        await maintenanceApi.getMaintenanceExpenseDirection(params);
      } catch (error) {
        notification.warn({
          message: 'Ошибка',
          description: error.message
        });
      }
    }
  };
  return (
    <Form initialValues={initialValue} enableReinitialize onSubmit={onSubmit}>
      {(FormField, formikProps) => {
        const {
          handleSubmit,
          setFieldValue,
          isSubmitting,
          values
        } = formikProps;
        // очищаем значения для пошагового заполнения первичных данных
        if (
        values.vehicleId === undefined &&
        values.maintenanceWorkTypeId !== undefined)
        {
          setFieldValue('type', undefined);
        }
        if (
        values.maintenanceWorkTypeId === undefined &&
        values.repairPlan !== undefined)
        {
          setFieldValue('description', undefined);
          setFieldValue('repairPlan', undefined);
          setFieldValue('maintenancePlannedDate', undefined);
        }
        if (
        values.repairPlan === undefined &&
        values.orderContractorType !== undefined)
        {
          setFieldValue('orderContractorType', undefined);
          setFieldValue('contractNumber', undefined);
          setFieldValue('contractorId', undefined);
          setFieldValue('executor', undefined);
          setFieldValue('executorId', undefined);
        }
        return (
          <form onSubmit={handleSubmit}>
            <Section>
              <SectionTitle divider>Первичные данные</SectionTitle>
              <Content>
                <Grid gutter="16px" cols={3}>
                  <GridItem>
                    <FormField
                      label="Транспортное средства"
                      required
                      fast
                      name="vehicleId">

                      {({ value, name }) =>
                      <VehicleSelect
                        disabled={values.id}
                        value={value}
                        filter={{
                          ownerType: ownerTypes.self
                        }}
                        onChange={(vehicleId) =>
                        setFieldValue(name, vehicleId)
                        } />

                      }
                    </FormField>
                  </GridItem>
                  {values.vehicleId &&
                  <GridItem>
                      <FormField
                      label="Вид работ"
                      required
                      fast
                      name="maintenanceWorkTypeId">

                        {({ value, name }) =>
                      <MaintenanceWorkTypeSelect
                        value={value}
                        onChange={(id) => {
                          setFieldValue(name, id);
                          const params = {
                            maintenanceWorkTypeId: id,
                            orderContractorType: values.orderContractorType,
                            repairPlan: values.repairPlan
                          };
                          checkExpenseDirection(params);
                        }} />

                      }
                      </FormField>
                    </GridItem>
                  }
                  {values.maintenanceWorkTypeId &&
                  <GridItem>
                      <FormField
                      label="График работ"
                      required
                      fast
                      name="repairPlan">

                        {({ value, name }) =>
                      <RepairePlanSelect
                        value={value}
                        onChange={(type) => {
                          setFieldValue(name, type);
                          const params = {
                            maintenanceWorkTypeId:
                            values.maintenanceWorkTypeId,
                            orderContractorType: values.orderContractorType,
                            repairPlan: value
                          };
                          checkExpenseDirection(params);
                        }} />

                      }
                      </FormField>
                    </GridItem>
                  }
                  {values.repairPlan &&
                  <GridItem>
                      <FormField
                      label="Планируемая дата проведения работ"
                      required
                      fast
                      name="maintenancePlannedDate">

                        {({ value, name }) =>
                      <DatePicker
                        name={name}
                        value={value ? moment(value) : value}
                        format="DD MMMM YYYY"
                        onChange={(value) => {
                          setFieldValue(
                            name,
                            moment.
                            utc(value).
                            startOf('day').
                            toISOString()
                          );
                        }} />

                      }
                      </FormField>
                    </GridItem>
                  }
                  {values.maintenancePlannedDate &&
                  <GridItem>
                      <FormField
                      label="Способ выполнения"
                      required
                      name="orderContractorType">

                        {({ value, name }) =>
                      <OrderContractorTypeSelect
                        name={name}
                        value={value}
                        onChange={(value) => {
                          setFieldValue(name, value);
                          const params = {
                            maintenanceWorkTypeId:
                            values.maintenanceWorkTypeId,
                            orderContractorType: value,
                            repairPlan: values.repairPlan
                          };
                          checkExpenseDirection(params);
                        }} />

                      }
                      </FormField>
                    </GridItem>
                  }
                  {showContractor(values) &&
                  <>
                      <GridItem>
                        <FormField
                        label="Подрядчик"
                        required={
                        maintenanceMatrix !== null &&
                        maintenanceMatrix.contractorRequired ===
                        maintenanceMatrixValidActionEnum.required
                        }
                        name="contractorId">

                          {({ value, name }) =>
                        <ContractorSelect
                          name={name}
                          value={value}
                          filter={{
                            services: serviceTypeEnum.maintenance
                          }}
                          onChange={(value) => {
                            setFieldValue(name, value);
                          }} />

                        }
                        </FormField>
                      </GridItem>
                      <GridItem>
                        <FormField
                        label="Договор"
                        required={
                        maintenanceMatrix !== null &&
                        maintenanceMatrix.contractorRequired ===
                        maintenanceMatrixValidActionEnum.required
                        }
                        name="contractNumber">

                          {({ value, name }) =>
                        <Input
                          name={name}
                          value={value}
                          onChange={(e) => {
                            setFieldValue(name, e.target.value);
                          }} />

                        }
                        </FormField>
                      </GridItem>
                    </>
                  }
                  <GridItem>
                    <FormField
                      label="Неисправности"
                      fast
                      name="description">

                      {(field) => <TextArea {...field} />}
                    </FormField>
                  </GridItem>
                </Grid>
              </Content>
            </Section>

            <Footer>
              <Button
                disabled={isSubmitting}
                loading={isSubmitting}
                type="primary"
                htmlType="submit">

                Сохранить
              </Button>
            </Footer>
          </form>);

      }}
    </Form>);

};
